import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div className="hs-section">
      <div className="hs-text">
        <p className="hs-label">Invest & Own</p>
        <h1 className="hs-title">Innovative Ownership & Investment Opportunities</h1>
        <p className="hs-desc">Beyond ownership. Become a stakeholder.
                              Co-own exceptional homes through CCPS participation.
                              Powered by hospitality income and real estate growth.
                              Value accrues in equity, not distributions.
                              Luxe Unbounded - an evolved asset class.</p>
        <Link to='/invest-own'><button className="hs-btn">Learn More About Investment</button></Link>
      </div>
      <div className="hs-image">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla4.webp?alt=media&token=5430db51-b6cb-478b-af6e-83128d06bd75"
          alt="Luxury Villa"
        />
      </div>
    </div>
  );
};

export default AboutSection;
